import React from 'react';
import { Container } from '../Container';
import { Label } from '../Label';
import { Button } from '../Button';
import { Reveal } from '../Reveal';
export function InfluencerHero() {
  return <section className="py-[clamp(70px,12vw,180px)]" data-id="element-110" data-mp="36hh6fko23eg4">
      <Container data-id="element-111" data-mp="36g61hhivk0nf">
        <Reveal data-id="element-112" data-mp="36emlzt51ltmp">
          <Label data-id="element-113" data-mp="32fnatqspx0mt">Influencer Management · A division of The Abie Agency</Label>
          <h1 className="mt-[28px] text-[clamp(3rem,10vw,10rem)] font-black uppercase leading-[0.88] tracking-[-0.04em]" data-id="element-114" data-mp="32dj83c6k27o4">
            We build influencers
            <br data-id="element-115" data-mp="29rzref36og1r" />
            into <span className="italic" data-id="element-116" data-mp="29sjahz4klahd">brands.</span>
          </h1>
          <p className="mt-[clamp(24px,3.5vw,40px)] max-w-[680px] text-[clamp(17px,1.4vw,22px)] leading-[1.45] text-[#1a1a1a]" data-id="element-117" data-mp="2nj4vpuhhxwif">
            A full-service management division for creators — brand development,
            content strategy, and deal-making handled end to end, so the talent
            can stay focused on the work.
          </p>
          <div className="mt-[clamp(28px,4vw,48px)] flex flex-wrap gap-[14px]" data-id="element-118" data-mp="1qy47zzj1uzos">
            <Button href="/contact" variant="solid" data-id="element-119" data-mp="2ecds5dqeu1wz">
              Apply for representation
            </Button>
            <Button href="/contact" variant="outline" data-id="element-120" data-mp="2j9noldc7vdub">
              Partner with us
            </Button>
          </div>
        </Reveal>
      </Container>
    </section>;
}